import React from 'react';

type Props = {
  responseHtml: string | undefined;
  unmappedVariablesCount: number;
};

const successText = (unmappedVariablesCount: number): string => {
  if (unmappedVariablesCount === 0) return 'Success';

  return `Success
    - Found ${unmappedVariablesCount} unmapped JSON ${
    unmappedVariablesCount > 1 ? 'paths' : 'path'
  }. Click "Done" to map them on the Connection page`;
};

const SuccessPane = (props: Props) => {
  const { responseHtml, unmappedVariablesCount } = props;

  return (
    <div className="test-connection-modal__step">
      <div className="test-connection-modal__success-title-wrap">
        <i className="fas fa-check-circle test-connection-modal__success-icon" />
        <span className="test-connection-modal__success-title">
          {successText(unmappedVariablesCount)}
        </span>
      </div>
      {responseHtml && (
        <div className="test-connection-modal__response-wrapper">
          <div className="test-connection-modal__response-title">Response</div>
          <div className="test-connection-modal__response-data">
            {responseHtml}
          </div>
        </div>
      )}
    </div>
  );
};

export default SuccessPane;
